'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';

import { ErrorBlock } from '@/components/internal/ErrorBlock';
import { GlobalStyles } from '@/styles/GlobalStyles';
import theme from '@/theme';

export default function DefaultErrorFallback() {
  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setTags({
        category: 'errorFallback',
        pathToFile: 'src/components/internal/DefaultErrorFallback.tsx',
      });

      scope.setLevel('fatal');

      Sentry.captureMessage('Unhandled error. Fallback rendered.');
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles theme={theme} />
      <ErrorBlock
        buttonText="Go home"
        image="/oopsImg.webp"
        logo={true}
        text={
          <>
            something went wrong. <br />
            Please, reload the page
          </>
        }
      />
    </ThemeProvider>
  );
}
